/* global axios */
import ApiClient from './ApiClient';

class GlobalNotificationSettings extends ApiClient {
  constructor() {
    super('global_notification_setting', { accountScoped: true });
  }

  update(params) {
    return axios.patch(`${this.url}`, params);
  }
}

export default new GlobalNotificationSettings();
